import React from 'react';
import { Select, Checkbox, List, Col, Row, Table, Button, Space, Input, Modal, message, Badge } from 'antd';
import { connect } from 'react-redux';
import { requestServerPost, selectPage, requestNodeServerPost, requestServerGet } from '../../actions';
import PlaylistTableView from '../views/PlaylistTableView';
import Column from 'antd/lib/table/Column';
import ActionButton from '../ActionButton';
import "./PlaylistSelectorPopup.css";
import PopupManager from '../../managers/PopupManager';
import DataHelper from '../../helpers/DataHelper';
import { ClockCircleFilled, ClockCircleOutlined, ClockCircleTwoTone, ExclamationCircleFilled, ExclamationCircleOutlined } from '@ant-design/icons';
import PermissionManager from '../../managers/PermissionManager';
import { THEME_PALLETE } from '../../Theme';

const { Option } = Select;
const columns = [
    {
        title: 'Screen Name',
        dataIndex: 'ScreenName',
        render: (value, record, index) => {
            return <Space size="small" style={{ display: "flex", justifyContent: "flex-start", alignItems: "center" }}> <Badge
                count={
                    record.PendingPublished == 1 ?
                        <ExclamationCircleFilled
                            style={{
                                fontWeight: 800,
                                color: THEME_PALLETE.orange,
                            }}
                        /> : 0
                }
                showZero={false}
            >
                <img style={{ width: "auto", height: "20px", objectFit: "cover", marginBottom: "3px" }} src="/cms/assets/svgs/icons/screen_icon.svg"></img>
            </Badge>
                {value}
            </Space>
        }
    },
    {
        title: 'Current Campaign',
        dataIndex: 'CampaignName',
    }
];
class PlaylistScreenSelectorPopup extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            screenDatas: [],
            selectedRowKeys: [], // Check here to configure the default column
            loading: false,
            screenNameFilter: ""
        }
    }

    componentDidMount() {
        this.reloadScreens();
    }


    checkContainsForiegnScreens = () => {

        const { playlistData = null } = this.props;

        return false;
        return this.state.selectedRowKeys.some(screenID => {
            const sData = this.state.screenDatas.find(sDat => { return sDat.ScreenID === screenID })
            return (sData.PlaylistID !== playlistData.PlaylistID)
        });
    }

    validateSelectingAll = () => {
        const screensWithCampaign = this.getScreensWithThisCampaign();

        return (this.state.selectedRowKeys.length === screensWithCampaign.length);
    }

    reloadScreens = (doUpdateSelections = true) => {

        const { brandid, selectedBranchData, playlistData } = this.props;

        DataHelper.getScreensByPlaylist({ brandid: brandid, branchid: selectedBranchData ? selectedBranchData.BranchID : undefined, playlistid: playlistData.PlaylistID }, this.props).then((data) => {
            this.setState({ screenDatas: data }, doUpdateSelections ? this.selectScreensWithThisCampaign : () => { })
        })
    }

    getScreensWithThisCampaign = (needsPublishOnly = false) => {
        const { playlistData = null } = this.props;
        return this.state.screenDatas.filter((s) => {
            if (needsPublishOnly) {
                return s.PendingPublished == 1
            }
            else {
                return true
            }
        }).map(d => { return d.ScreenID });
    }

    selectScreensWithThisCampaign = () => {

        const { playlistData = null } = this.props;
        const screenWithCampaign = this.getScreensWithThisCampaign(false);
        this.setState({ selectedRowKeys: screenWithCampaign })
    }
    filter = (inputValue, path) => {
        return path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1);
    }

    onChange = (value, selectedOptions) => {
        const { onChange } = this.props;
        onChange(value, selectedOptions);
    }

    renderList = () => {

        const { onItemSelected = () => { } } = this.props
        const mappedData = this.state.screenDatas.map(d => {
            return { ...d, key: d.ScreenID }
        })
        return (

            <List
                size="medium"
                header={<div>Select Screens To Assign to</div>}
                footer={<div></div>}
                bordered
                dataSource={mappedData}
                renderItem={item =>
                    <div onClick={() => {
                        onItemSelected(item)
                        PopupManager.closePopup();
                    }} className="center-content playlist-choice" style={{ padding: "2px", border: "1px solid #f0f0f0", borderRadius: "4px" }}>
                        <Row align="middle" justify="space-between" gutter={[4, 0]} style={{ width: "95%", height: "30px", cursor: "pointer" }}>
                            <Col span={20}><img style={{ width: "20px", height: "20px", marginRight: "16px" }} src="/cms/assets/svgs/icons/screen_icon.svg"></img>{item.ScreenName}</Col>

                        </ Row>
                    </div>}
            />
        )
    }

    // assignToScreens = () => {

    //     const { requestServerPost, usertoken, playlistData = null } = this.props;

    //     if (!playlistData)
    //         return;
    //     const params = new FormData();
    //     const screenids = this.state.selectedRowKeys.join(",")

    //     var arr = [{ screenids: screenids, Playlistid: playlistData.PlaylistID }];

    //     params.append("screens", JSON.stringify(arr))

    //     requestServerPost("update_screencampaign", params, {}, (response) => {
    //         this.reloadScreens(false);
    //     }, usertoken);
    // }

    // save = () => {

    //     const { brandid, playlistData = null } = this.props;
    //     const hasOverrides = this.state.selectedRowKeys.some(screenID => {
    //         const sData = this.state.screenDatas.find(sDat => { return sDat.ScreenID === screenID })
    //         return (sData.PlaylistID !== playlistData.PlaylistID) && sData.PlaylistID !== ""
    //     })

    //     if (hasOverrides) {
    //         Modal.confirm({
    //             title: 'Confirm',
    //             icon: <ExclamationCircleOutlined />,
    //             content: `One or more selected screens are currently assigned with other campaigns, would you like to replace them with "${playlistData.CampaignName}"?`,
    //             okText: 'OK',
    //             cancelText: 'Cancel',
    //             onOk: this.assignToScreens
    //         });
    //     }
    //     else {
    //         this.assignToScreens();
    //     }
    // }

    publish = () => {
        const selectedScreens = this.state.selectedRowKeys.map(screenID => {
            return this.state.screenDatas.find(sDat => { return sDat.ScreenID === screenID })
        })

        Modal.confirm({
            title: 'Confirm',
            icon: <ExclamationCircleOutlined />,
            content: `Are you sure to publish content to the selected ${selectedScreens.length} screen(s)?`,
            okText: 'OK',
            cancelText: 'Cancel',
            onOk: () => {
                DataHelper.publishContent(selectedScreens, () => {
                    message.success(`Successfully published content to ${selectedScreens.length} screen(s)`);
                    // this.reloadPage();
                    this.reloadScreens();
                }, this.props)
            }
        });


    }

    onSelectChange = selectedRowKeys => {
        this.setState({ selectedRowKeys });
    };

    onSelectCampaignScreensChanged = (e) => {
        const checked = e.target.checked;

        if (checked) {
            this.selectScreensWithThisCampaign();
        }
    }

    updateFilter = (e) => {
        const filter = e.target.value;
        this.setState({ screenNameFilter: filter });
    }

    render() {
        const { playlistData } = this.props;
        const { loading, selectedRowKeys } = this.state;
        const rowSelection = {
            selectedRowKeys,
            onChange: this.onSelectChange,
            selections: [
                Table.SELECTION_ALL,
                Table.SELECTION_INVERT,
                {
                    key: 'all_campaign',
                    text: `Select Screens with "${playlistData.PlaylistName}"`,
                    onSelect: changableRowKeys => {
                        const screensWithThisCampaign = this.getScreensWithThisCampaign();
                        this.setState({ selectedRowKeys: screensWithThisCampaign });
                    },
                }
            ],
            preserveSelectedRowKeys: true
        };
        const hasSelected = selectedRowKeys.length > 0;
        const isSelectingAll = this.validateSelectingAll();
        // const needSave = this.state.selectedRowKeys.some(screenID => {
        //     const sData = this.state.screenDatas.find(sDat => { return sDat.ScreenID === screenID })
        //     return (sData.PlaylistID !== playlistData.PlaylistID)
        // });


        const allowPublishPermission = PermissionManager.checkPermission(PermissionManager.PERMISSION_KEY_SCREEN, PermissionManager.PERMISSION_TYPE_PUBLISH);
        // const canPublish = !needSave && hasSelected;
        const canPublish = hasSelected;

        const mappedData = this.state.screenDatas.map((d, index) => {
            return { ...d, key: d.ScreenID }
        }).filter(sData => {
            return sData.ScreenName.toLocaleLowerCase().includes(this.state.screenNameFilter.toLocaleLowerCase());
        })
        // .sort((a, b) => {
        //     const aValue = (this.state.selectedRowKeys.indexOf(a.ScreenID) > -1) ? -1 : 0
        //     const bValue = (this.state.selectedRowKeys.indexOf(b.ScreenID) > -1) ? -1 : 0

        //     return aValue - bValue
        // })


        return (
            // <Cascader
            //     options={this.state.playlistOptions}
            //     onChange={this.onChange}
            //     placeholder="Select Playlist"
            //     showSearch={this.filter}
            // />
            <div style={{ margin: 24 }}>
                <div style={{ marginBottom: 16, display: "flex", alignItems: "center", justifyContent: "space-between" }}>
                    <Space>
                        <Space>
                            {/* <Button type="primary" onClick={this.save} disabled={!needSave} loading={loading}>
                                Assign To
                            </Button> */}
                            {allowPublishPermission ? (
                                <Button type="primary" onClick={this.publish} disabled={!canPublish} loading={loading}>
                                    Publish
                                </Button>
                            ) : null}

                        </Space>
                    </Space>
                    <span style={{ marginLeft: 8 }}>
                        {hasSelected ? `Selected ${selectedRowKeys.length} screens` : ''}
                    </span>
                </div>
                <Input onChange={this.updateFilter} value={this.state.screenNameFilter} placeholder="Filter with screen names" style={{ marginBottom: "8px" }}></Input>
                <Table rowSelection={rowSelection} columns={columns} dataSource={mappedData} />
                <Checkbox onChange={this.onSelectCampaignScreensChanged} checked={isSelectingAll}>{`Every Screen with "${playlistData.PlaylistName}"`}</Checkbox>

            </div>
            // <>{this.renderList()}</>

        )
    }
}

const mapStateToProps = (state) => {
    return { userdata: state.userdata, usertoken: state.usertoken, selectedBrandData: state.selectedBrandData, selectedBranchData: state.selectedBranchData, selectedBranchData: state.selectedBranchData };
}

export default connect(mapStateToProps, { requestServerGet, requestServerPost, selectPage, requestNodeServerPost })(PlaylistScreenSelectorPopup);